import React from 'react';
import { TreeSelect as OriginTreeSelect } from 'antd';

const TreeSelect: any = (props: any) => {
  return <OriginTreeSelect {...props} />;
};

export default TreeSelect;
